import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { StatusColor } from 'src/app/shared/status-indicator/status-indicator.component';

@Component({
  selector: 'dcc-module-status-cell',
  template: `
    <dcc-status-indicator
      *ngIf="value !== 'N/A'; else notApplicable"
      [color]="color"
      [value]="value"
    ></dcc-status-indicator>
    <ng-template #notApplicable>
      <span>N/A</span>
    </ng-template>
  `,
})
export class ModuleStatusComponent implements ICellRendererAngularComp {
  @Input() value: string;
  @Input() color: StatusColor = StatusColor.blue;

  params: any;

  agInit(params: any): void {
    this.params = params;
    this.setStatusProperties(params);
  }

  refresh(params: any): boolean {
    this.setStatusProperties(params);
    return true;
  }

  private setStatusProperties(params: any): void {
    this.value = params.data.status;
    const status = params.data.status;
    switch (status) {
      case 'Installed':
        this.color = StatusColor.green;
        break;
      case 'Pending':
        this.color = StatusColor.yellow;
        break;
      case 'N/A':
        this.color = StatusColor.none;
        break;
      case 'None':
        this.color = StatusColor.none;
        break;
      default:
        this.color = StatusColor.red;
        break;
    }
  }
}
